// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Siirretty ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => 'Komento',
  accControlKey: () => 'Sulje',
  accPositionAfter: () => 'jälkeen',
  accPositionBefore: () => 'ennen',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Pidä ' +
    p['keyPressed'] +
    '-näppäintä ja vaihtonäppäintä alas painettuina ja järjestä sitten uudelleen nuolinäppäimillä.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Syötä täydellinen päivämäärä tässä muodossa: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Syötä kuukausi ja vuosi tässä muodossa: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Ryhmä',
  chart_labelSeries: () => 'Sarja',
  chart_labelValue: () => 'Arvo',
  checkboxSet_requiredMessageDetail: () => 'Pakollinen',
  checkbox_requiredMessageDetail: () => 'Pakollinen',
  close: () => 'Sulje',
  collection_noData: () => 'Ei näytettäviä tietoja.',
  collection_selectAllRows: () => 'Valitse kaikki rivit',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Valitse rivi ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Ei lajiteltava',
  collection_sortEnabled: () => 'Lajiteltava',
  confirmation: () => 'Confirmation',
  datePicker_currentDate: () => 'Nykyinen pvm',
  datePicker_goToToday: () => 'Siirry tähän päivään',
  datePicker_label: () => 'Päivämäärän valinta',
  datePicker_month: () => 'Kuukausi',
  datePicker_months: () => 'Kuukaudet',
  datePicker_next: () => 'Seuraava',
  datePicker_nextDecade: () => 'Seuraava vuosikymmen',
  datePicker_nextMonth: () => 'Seuraava kuukausi',
  datePicker_prev: () => 'Edellinen',
  datePicker_prevDecade: () => 'Edellinen vuosikymmen',
  datePicker_prevMonth: () => 'Edellinen kuukausi',
  datePicker_restricted: () => 'Rajoitettu',
  datePicker_selected: () => 'Valittu',
  datePicker_today: () => 'Tänään',
  datePicker_weekNum: (p: { NUM: string }) => 'Viikko ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Viikon numero',
  datePicker_year: () => 'Vuosi',
  datePicker_years: () => 'Vuodet',
  error: () => 'Virhe',
  expandableList_expandCollapseInstructionText: () => 'Laajenna ja tiivistä nuolinäppäimillä',
  expandableList_groupCollapse: () => 'Tiivistetty',
  expandableList_groupExpand: () => 'Laajennettu',
  filePicker_addFiles: () => 'Lisää tiedostoja',
  filePicker_dropzonePrimaryText: () => 'Vedä ja pudota',
  filePicker_dropzoneSecondaryText: () => 'Valitse tiedosto tai vedä se tähän',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Valitse tai pudota tiedostot tähän',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Seuraavien tyyppien tiedostoja ei voi ladata: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Lataa yksi tiedosto kerrallaan',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Tyypin ' + p['fileType'] + ' tiedostoja ei voi ladata',
  filePicker_unknownFileTypeUploadError: () => 'tuntematon',
  formControl_clear: () => 'Tyhjennä',
  formControl_day: () => 'Päivä',
  formControl_helpAvailable: () => 'Ohje käytettävissä',
  formControl_hide: () => 'Piilota',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Olet saavuttanut ' +
    ((
      { one: new Intl.NumberFormat('fi').format(p['CHARACTER_LIMIT']) + '-merkin' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('fi').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('fi').format(p['CHARACTER_LIMIT']) + '-merkin') +
    ' rajan.',
  formControl_loading: () => 'Ladataan',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Voit syöttää enintään ' + p['MAX_LENGTH'] + ' merkkiä.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' merkkiä jäljellä.',
  formControl_month: () => 'Kuukausi',
  formControl_readOnly: () => 'Vain luku',
  formControl_requiredMessageDetail: () => 'Syötä arvo.',
  formControl_show: () => 'Näytä',
  formControl_year: () => 'Vuosi',
  gantt_labelDate: () => 'Päivämäärä',
  gantt_labelEnd: () => 'Loppu',
  gantt_labelLabel: () => 'Otsikko',
  gantt_labelRow: () => 'Rivi',
  gantt_labelStart: () => 'Alku',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Vastaavaa osaa ei löytynyt.',
  indexer_keyboardInstructionText: () => 'Valitse arvo painamalla Enter-näppäintä.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Välillä ' + p['FROM_SECTION'] + ' ja ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Siirry eletilaan kaksoisnapauttamalla ja painamalla ja säädä sitten arvoa vetämällä ylös- tai alaspäin.',
  info: () => 'Tiedot',
  inputDateMask_date_cleared: () => 'Tyhjennyspäivä',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tyhjennä',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Syötä päivämäärä, joka on ' + p['max'] + ' tai sitä ennen.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Syötä päivämäärä, joka on ' + p['min'] + ' tai sen jälkeen.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Syötä käytettävissä oleva päivämäärä.',
  inputDatePicker_instruction: () => 'Avaa kalenteri painamalla sarkainta',
  inputDatePicker_selectDate: () => 'Valitse pvm',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Syötä kuukausi ja vuosi, jotka ovat ' + p['max'] + ' tai sitä ennen.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Syötä kuukausi ja vuosi, jotka ovat ' + p['min'] + ' tai sen jälkeen.',
  inputNumber_converterParseError: () => 'Anna numero.',
  inputNumber_decrease: () => 'Vähennys',
  inputNumber_increase: () => 'Lisäys',
  inputPassword_hidden: () => 'Salasana piilotettu',
  inputPassword_hide: () => 'Piilota salasana',
  inputPassword_show: () => 'Näytä salasana',
  inputSensitiveText_hidden: () => 'Arkaluonteinen teksti on piilotettu',
  list_msgFetchCompleted: () => 'Ladattu',
  list_msgFetchingData: () => 'Ladataan',
  list_suggestion: () => 'Ehdotus',
  messageToast_allMessagesClosed: () => 'Kaikki näyttöviestit on suljettu.',
  message_close: () => 'Sulje',
  message_confirmation: () => 'Onnistui',
  message_error: () => 'Virhe',
  message_info: () => 'Tiedot',
  message_navigationFromMessagesRegion: () =>
    'Siirrytään viestialueelle. Siirry takaisin kohdistettuun elementtiin F6-näppäimellä.',
  message_navigationToMessagesRegion: () =>
    'Viestialueella on uusia viestejä. Siirry viimeisimmälle viestialueelle F6-näppäimellä.',
  message_warning: () => 'Varoitus',
  noData_message: () => 'Ei sisältöä',
  overflowItemLabel: () => 'Lisää välilehtiä',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Käynnissä',
  radio_helpForRadio: () => 'Valintanapin ohje',
  radio_requiredMessageDetail: () => 'Valitse arvo.',
  selectMultiple_apply: () => 'Käytä',
  selectMultiple_back: () => 'Edellinen',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Korosta valitut arvot vasemmalla ja oikealla nuolinäppäimellä.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Voit poistaa valitun arvon askelpalauttimella tai poistonäppäimellä.',
  selectMultiple_selectedValues: () => 'Valitut arvot',
  selectMultiple_showSelectedValues: () => 'Näytä vain valitut arvot.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' arvoa valittu.',
  select_addToList: () => 'Lisää luetteloon',
  select_addToListAvailable: () => 'Lisää käytettävissä olevien luetteloon',
  select_moreSearchOptions: () => 'Lisää hakuvalintoja',
  select_moreSearchOptionsAvailable: () => 'Lisää hakuvaihtoehtoja on käytettävissä',
  select_noMatchesFound: () => 'Vastineita ei löydy.',
  select_oneMatchFound: () => 'Yksi vastaavuus löydettiin',
  select_requiredMessageDetail: () => 'Valitse arvo.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' osumaa',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Vähintään ' + p['TOTAL_SIZE'] + ' osumaa',
  selectorAll_deselectAll: () => 'Poista kaikki valinnat',
  selectorAll_selectAll: () => 'Valitse kaikki',
  selector_selected: () => 'Valintaruutu on valittu',
  selector_unselected: () => 'Valintaruutua ei ole valittu',
  tabBarNavigationList_removeCueText: () => 'Poistettava',
  timeComponent_tooltipZoomIn: () => 'Lähennä',
  timeComponent_tooltipZoomOut: () => 'Loitonna',
  train_current: () => 'Nykyinen',
  train_message_type: () => 'Viestin tyyppi',
  train_not_visited: () => 'Ei käyty',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Vaihe ' + p['currentStep'] + '/' + p['numberOfSteps'],
  train_visited: () => 'Käyty',
  userAssistance_learnMore: () => 'Lisätietoja',
  userAssistance_required: () => 'Pakollinen',
  vis_clearSelection: () => 'Tyhjennä valinnat',
  vis_drillable: () => 'Siirryttävä',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + '/' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Alueen valinta',
  vis_marqueeZoomTooltip: () => 'Zoomausvalinta',
  vis_noData: () => 'Ei näytettäviä tietoja',
  vis_panTooltip: () => 'Panoroi',
  vis_stateLoaded: () => 'Ladattu',
  vis_stateLoading: () => 'Ladataan',
  vis_stateSelected: () => 'Valittu',
  vis_stateUnselected: () => 'Ei valittu',
  warn: () => 'Varoitus'
};
export default bundle;
